import { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import AuthHeader from '../components/AuthHeader';
import axios from 'axios';
import SweetAlert from '../components/SweetAlert';
import PhoneInput, { isValidPhoneNumber } from "react-phone-number-input";
import "react-phone-number-input/style.css";
import '../assets/styles/common.css';
import eyeIcon from '../assets/images/eye.png';
import eyeCloseIcon from '../assets/images/eyeClose.png';

const Register = () => {
  const navigate = useNavigate();
  const [step, setStep] = useState(1);
  const [loading, setLoading] = useState(false);
  const [showPassword, setShowPassword] = useState(false);
  const [showConfirmPassword, setShowConfirmPassword] = useState(false);

  const [formData, setFormData] = useState({
    //step 1
    email: "",
    //step 2
    otp: "",
    //step 3
    password: "",
    confirmPassword: ""
});

  const [errors, setErrors] = useState({});

  const [timeLeft, setTimeLeft] = useState(60);

const startTimer = () => {
    setTimeLeft(60);
};

useEffect(() => {

    if (step !== 2) return;

    if (timeLeft <= 0) return;

    const timer = setInterval(() => {

        setTimeLeft(prev => prev - 1);

    }, 1000);

    return () => clearInterval(timer);

}, [step, timeLeft]);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData(prev => ({ ...prev, [name]: value }));
    
    // Clear error when user starts typing
    if (errors[name]) {
      setErrors(prev => ({ ...prev, [name]: '' }));
    }
  };

  const validateStep1 = () => {
    const newErrors = {};
  
    if (!formData.email.trim()) newErrors.email = "Email is required";
    else if (!/\S+@\S+\.\S+/.test(formData.email)) newErrors.email = "Invalid email address";
  
    setErrors(newErrors);
    return Object.keys(newErrors).length === 0;
  };

  const validateStep2 = () => {
    const newErrors = {};
   
    if (!formData.otp.trim()) newErrors.otp = "OTP is required";
    else if (formData.otp.length !== 6) newErrors.otp = "OTP must be 6 digits";
  
    setErrors(newErrors);
    return Object.keys(newErrors).length === 0;
  };

  const validateStep3 = () => {
    const newErrors = {};
    if (!formData.password.trim()) newErrors.password = "Password is required";
    else if (formData.password.length < 6) newErrors.password = "Password must be at least 6 characters";
    if (!formData.confirmPassword.trim()) newErrors.confirmPassword = "Confirm password is required";
    else if (formData.confirmPassword !== formData.password) newErrors.confirmPassword = "Passwords do not match";
    setErrors(newErrors);
    return Object.keys(newErrors).length === 0;
  };

  // const nextStep = () => {
  //   if (step === 1) {
  //     if (validateStep1()) {
       
  //       setStep(2);
  //     }
  //   } else if (step === 2) {
  //     if (validateStep2()) {
  //       setStep(3);
  //     }
  //   }
  // };

  const prevStep = () => setStep(step - 1);

  const sendOtp = async () => {

    if (!validateStep1()) return;

    setLoading(true);

    try {

        const response = await axios.post(
            `${process.env.REACT_APP_API_URL}/api/website/forgot-password`,
            {
                email: formData.email
            }
        );

        setLoading(false);

        if (response.data.status === 1) {

            SweetAlert.success(
                "OTP Sent",
                "OTP has been sent to your email."
            );

            setStep(2);
            startTimer();

        } else {

            SweetAlert.error(response.data.message);

        }

    } catch (err) {
      console.log(err);

        setLoading(false);

        SweetAlert.error(
            err.response?.data?.message || "Something went wrong"
        );

    }

};

const verifyOtp = async () => {

  if (!validateStep2()) return;

  setLoading(true);

  try {

      const response = await axios.post(
          `${process.env.REACT_APP_API_URL}/api/website/verify-forgot-otp`,
          {
              email: formData.email,
              otp: formData.otp
          }
      );

      setLoading(false);

      if (response.data.status === 1) {

          SweetAlert.success(
              "OTP Verified",
              "Please create a new password."
          );

          setStep(3);

      } else {

          SweetAlert.error(response.data.message);

      }

  } catch (err) {

      setLoading(false);

      SweetAlert.error(
          err.response?.data?.message || "Something went wrong"
      );

  }

};
const updatePassword = async () => {

  if (!validateStep3()) return;

  setLoading(true);

  try {

      const response = await axios.post(
          `${process.env.REACT_APP_API_URL}/api/website/reset-password`,
          {
              email: formData.email,
              password: formData.password
          }
      );

      setLoading(false);

      if (response.data.status === 1) {

          SweetAlert.success(
              "Password Updated",
              "Your password has been updated successfully."
          );

          navigate("/");

      } else {

          SweetAlert.error(response.data.message);

      }

  } catch (err) {

      setLoading(false);

      SweetAlert.error(
          err.response?.data?.message || "Something went wrong"
      );

  }

};

 

  const handleFinalSubmit = () => {
    setLoading(true);
    // Your API call here
    axios.post(`${process.env.REACT_APP_API_URL}/api/website/register-agency`, formData)
      .then(response => {
        setLoading(false);
        if (response.data.status === 1) {
          //alert("✅ Registration Successful!");
          SweetAlert.success("Registration Successful!", "Your application has been submitted successfully.");
          navigate('/');
        } else {
          //alert(response.data.message || "Submission failed");
          SweetAlert.error(response.data.message || "Submission failed");
        }
      })
      .catch(error => {
        setLoading(false);
        //alert(error.response.data.message || "Server error. Please try again.");
        SweetAlert.error(error.response.data.message || "Server error. Please try again.");
      });
  };

  return (
    <div className="container py-5">
      <div className="row justify-content-center">
        <div className="col-lg-10">

          <AuthHeader subtitle="Password Recovery" />

          <h1 className="text-center mb-2">Password Recovery</h1>
          <p className="text-center text-muted mb-5">
            Follow the steps below to verify your identity and securely reset your account password.
          </p>

          
          {/* Stepper with Checkmark */}
          <div className="d-flex justify-content-center mb-5">
            <div className="d-flex align-items-center">
              <div className={`rounded-circle d-flex align-items-center justify-content-center ${step >= 1 ? 'bg-primary text-white' : 'bg-secondary text-white'}`} style={{width: '40px', height: '40px'}}>
                {step > 1 ? '✓' : '1'}
              </div>
              <span className="mx-3 fw-bold">Verify Identity</span>

              <div className={`border-bottom flex-grow-1 mx-3 ${step >= 2 ? 'border-primary' : 'border-secondary'}`} style={{height: '2px', width: '80px'}}></div>

              <div className={`rounded-circle d-flex align-items-center justify-content-center ${step >= 2 ? 'bg-primary text-white' : 'bg-secondary text-white'}`} style={{width: '40px', height: '40px'}}>
                {step > 2 ? '✓' : '2'}
              </div>
              <span className="mx-3 fw-bold">Verify OTP</span>

              <div className={`border-bottom flex-grow-1 mx-3 ${step >= 3 ? 'border-primary' : 'border-secondary'}`} style={{height: '2px', width: '80px'}}></div>

              <div className={`rounded-circle d-flex align-items-center justify-content-center ${step >= 3 ? 'bg-primary text-white' : 'bg-secondary text-white'}`} style={{width: '40px', height: '40px'}}>
                3
              </div>
              <span className="mx-3 fw-bold">Reset Password</span>
            </div>
          </div>

          {/* Step 1 */}
          {step === 1 && (
            <div className="card shadow">
              <div className="card-body p-5">
                <h4 className="mb-4">Verify Identity</h4>

                <div className="row g-4">
                  <div className="col-12">
                    <label className="form-label">Email Address <span className="text-danger">*</span></label>
                    <input type="email" name="email" value={formData.email} onChange={handleChange} className="form-control" />
                    {errors.email && <small className="text-danger">{errors.email}</small>}
                  </div>

                </div>

                <div className="d-flex gap-3 mt-5">
                  {/* <button className="btn btn-secondary px-4" onClick={() => navigate('/')}>Cancel</button> */}
                  <button className="btn btn-primary px-5" onClick={sendOtp}>Send OTP →</button>
                </div>
              </div>
            </div>
          )}

          {/* ==================== STEP 2  ==================== */}
          {step === 2 && (
          <div className="card shadow-sm">
            <div className="card-body p-5">

              <h4 className="mb-4">Verify OTP</h4>

              <div className="row g-4">

                <div className="col-12">
                  <label className="form-label">
                    Email Address
                  </label>

                  <input
                    type="email"
                    className="form-control"
                    value={formData.email}
                    readOnly
                  />
                </div>

                <div className="col-12">
                  <label className="form-label">
                    Enter OTP
                    <span className="text-danger">*</span>
                  </label>

                  <input
                    type="text"
                    className="form-control"
                    name="otp"
                    placeholder="Enter 6 digit OTP"
                    value={formData.otp}
                    onChange={handleChange}
                    maxLength={6}
                  />

                  {errors.otp && (
                    <small className="text-danger">
                      {errors.otp}
                    </small>
                  )}
                </div>

                <div className="col-12">

                  <p className="text-muted mb-2">
                    OTP expires in
                    <strong className="ms-2">
                      {String(Math.floor(timeLeft / 60)).padStart(2, "0")}:
                      {String(timeLeft % 60).padStart(2, "0")}
                    </strong>
                  </p>

                  <button
                    className="btn btn-link p-0"
                    disabled={timeLeft > 0}
                    onClick={sendOtp}
                  >
                    Resend OTP
                  </button>

                </div>

              </div>

              <div className="d-flex gap-3 mt-5">

                <button
                  className="btn btn-secondary"
                  onClick={prevStep}
                >
                  ← Back
                </button>

                <button
                  className="btn btn-primary"
                  onClick={verifyOtp}
                >
                  Verify OTP
                </button>

              </div>

            </div>
          </div>
        )}

          {/* ==================== STEP 3: ==================== */}
          {step === 3 && (
          <div className="card shadow-sm">
          <div className="card-body p-5">

          <h4 className="mb-4">
          Reset Password
          </h4>

          <div className="row g-4">

          <div className="col-md-6">
          <label>
          New Password
          <span className="text-danger">*</span>
          </label>

          <div className="password-container">
            <input
            type={showPassword ? 'text' : 'password'}
            className="form-control"
            name="password"
            value={formData.password}
            onChange={handleChange}
            />
            <img
              src={showPassword ? eyeCloseIcon : eyeIcon}
              alt={showPassword ? 'Hide password' : 'Show password'}
              className="password-toggle"
              onClick={() => setShowPassword(prev => !prev)}
            />
          </div>

          {errors.password &&
          <small className="text-danger">
          {errors.password}
          </small>}
          </div>

          <div className="col-md-6">

          <label>
          Confirm Password
          <span className="text-danger">*</span>
          </label>

          <div className="password-container">
            <input
            type={showConfirmPassword ? 'text' : 'password'}
            className="form-control"
            name="confirmPassword"
            value={formData.confirmPassword}
            onChange={handleChange}
            />
            <img
              src={showConfirmPassword ? eyeCloseIcon : eyeIcon}
              alt={showConfirmPassword ? 'Hide password' : 'Show password'}
              className="password-toggle"
              onClick={() => setShowConfirmPassword(prev => !prev)}
            />
          </div>

          {errors.confirmPassword &&
          <small className="text-danger">
          {errors.confirmPassword}
          </small>}

          </div>

          </div>

          <div className="d-flex gap-3 mt-5">

          <button
          className="btn btn-outline-secondary"
          onClick={prevStep}
          >
          ← Back
          </button>

          <button
          className="btn btn-primary flex-grow-1"
          onClick={updatePassword}
          disabled={loading}
          >
          {loading ? "Updating..." : "Update Password"}
          </button>

          </div>

          </div>
          </div>
          )}
        </div>
      </div>
    </div>
  );
};

export default Register;